import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Dashboard from 'feature/global-data/Dashboard';
import Points from 'feature/global-data/points/Points';
import Products from 'feature/global-data/products/Products';
import Destinations from 'feature/global-data/destinations/Destinations';

const GlobalRoutes = () => (
  <Routes>
    <Route element={<Dashboard />} index />
    <Route element={<Points />} path="points" />
    <Route element={<Products />} path="products" />
    <Route element={<Destinations />} path="destinations" />
  </Routes>
);

export default GlobalRoutes;
